import { Check } from "lucide-react";

export default function QuestionnaireStepper({ steps, current, done, completion, onGo }) {
  return (
    <div data-testid="q-stepper" className="space-y-3">
      <div className="flex items-center justify-between text-xs">
        <span className="uppercase tracking-widest text-[#C9A85A]">Avancement de votre fiche</span>
        <span data-testid="q-completion" className="font-semibold text-[#1B2A4A]">{completion}% complété</span>
      </div>
      <div className="h-1.5 bg-gray-100 overflow-hidden"><div className="h-full bg-[#E0C173] transition-all duration-500" style={{ width: `${completion}%` }} /></div>
      <ol className="grid grid-cols-6 gap-1.5">
        {steps.map((s, i) => {
          const active = i === current;
          const ok = done[i];
          return (
            <li key={s.title}>
              <button type="button" data-testid={`q-step-${i}`} onClick={() => onGo(i)} title={s.title}
                className={`w-full flex flex-col items-center gap-1 py-1.5 transition-colors ${active ? "text-[#1B2A4A]" : "text-gray-500 hover:text-[#1B2A4A]"}`}>
                <span className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold border-2 transition-colors ${active ? "bg-[#1B2A4A] border-[#1B2A4A] text-white" : ok ? "bg-[#E0C173] border-[#E0C173] text-[#1B2A4A]" : "bg-white border-gray-300"}`}>
                  {ok && !active ? <Check className="w-4 h-4" /> : i + 1}
                </span>
                <span className="hidden sm:block text-[10px] leading-tight text-center">{s.short}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
